export const GET_TEACHER_LESSONPLAN = "GET_TEACHER_LESSONPLAN"
export const GET_TEACHER_LESSONPLAN_SUCCESS = "GET_TEACHER_LESSONPLAN_SUCCESS"
export const GET_TEACHER_LESSONPLAN_FAILED = "GET_TEACHER_LESSONPLAN_FAILED"

export const ADD_NEW_LESSONPLAN = "ADD_NEW_LESSONPLAN"
export const ADD_NEW_LESSONPLAN_SUCCESS = "ADD_NEW_LESSONPLAN_SUCCESS"
export const ADD_NEW_LESSONPLAN_FAILED = "ADD_NEW_LESSONPLAN_FAILED"

export const UPDATE_LESSONPLAN = "UPDATE_LESSONPLAN"
export const UPDATE_LESSONPLAN_SUCCESS = "UPDATE_LESSONPLAN_SUCCESS"
export const UPDATE_LESSONPLAN_FAILED = "UPDATE_LESSONPLAN_FAILED"


export const GET_STUD_LESSONPLAN = "GET_STUD_LESSONPLAN"
export const GET_STUD_LESSONPLAN_SUCCESS = "GET_STUD_LESSONPLAN_SUCCESS"
export const GET_STUD_LESSONPLAN_FAILED = "GET_STUD_LESSONPLAN_FAILED"


export const GET_ADMIN_LESSONPLAN = "GET_ADMIN_LESSONPLAN"
export const GET_ADMIN_LESSONPLAN_SUCCESS = "GET_ADMIN_LESSONPLAN_SUCCESS"
export const GET_ADMIN_LESSONPLAN_FAILED = "GET_ADMIN_LESSONPLAN_FAILED"